import { GridOptions, ColDef } from 'ag-grid-community'
import { OrganisationPrimeBrokerDetail } from 'api'
import { Translation, Locale } from 'locale'
import { createActionsRenderer, gridOptionsBase, TypedValueGetterParams } from 'view/components/datagrid'
import { PrimeBrokerDefaultsActionsButton } from './PrimeBrokerDefaultsActionsButton'

export enum PrimeBrokersGridColumnId {
  ACTIONS = 'PRIME_BROKERS_ACTIONS',
  MY_ENTITY = 'PRIME_BROKERS_MY_ENTITY',
  COUNTERPARTY_NAME = 'PRIME_BROKERS_COUNTERPARTY',
  PRIME_BROKER = 'PRIME_BROKERS_PRIME_BROKER'
}

export const primeBrokerDefaultsGridOptions: GridOptions<OrganisationPrimeBrokerDetail> = {
  ...gridOptionsBase,
  getRowId: ({ data }) => data.id
}

export const primeBrokerDefaultsColumnDefs: ColDef[] = [
  {
    colId: PrimeBrokersGridColumnId.ACTIONS,
    headerName: Locale.translate(Translation.TC_EMPTY_HEADER),
    equals: () => false,
    width: 200,
    cellRenderer: createActionsRenderer(PrimeBrokerDefaultsActionsButton),
    cellClass: 'action-cell',
    pinned: 'left',
    lockPinned: true,
    lockPosition: true,
    lockVisible: true,
    enableRowGroup: false,
    filter: false,
    sortable: false
  },
  {
    colId: PrimeBrokersGridColumnId.MY_ENTITY,
    valueGetter: (params: TypedValueGetterParams<OrganisationPrimeBrokerDetail>) => {
      return params.data?.ownerTradingEntity && params.data.ownerTradingEntity.publishedName
    },
    headerName: Locale.translate(Translation.TC_MY_ENTITY),
    width: 200,
    filter: 'agSetColumnFilter',
    lockVisible: true
  },
  {
    colId: PrimeBrokersGridColumnId.COUNTERPARTY_NAME,
    valueGetter: (params: TypedValueGetterParams<OrganisationPrimeBrokerDetail>) =>
      params.data?.subjectTradingEntity && params.data.subjectTradingEntity.publishedName,
    headerName: Locale.translate(Translation.TC_PRIME_BROKER_DEFAULTS_COUNTERPARTY_NAME),
    width: 200,
    filter: 'agSetColumnFilter',
    lockVisible: true
  },
  {
    colId: PrimeBrokersGridColumnId.PRIME_BROKER,
    valueGetter: (params: TypedValueGetterParams<OrganisationPrimeBrokerDetail>) =>
      params.data?.primeBroker && params.data.primeBroker.name,
    headerName: Locale.translate(Translation.TC_PRIME_BROKER_DEFAULTS_PRIME_BROKER),
    width: 200,
    filter: 'agSetColumnFilter',
    lockVisible: true
  }
]
